import { module } from 'modujs';
import modularLoad from 'modularload';
import gsap from 'gsap';
import { html, body } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        gsap.delayedCall(window.readyDelay,() => {
            this.setSizes();
        });

        const load = new modularLoad({
            enterDelay: 0,
            exitDelay: 1400,
            transitions: {
            }
        });

        load.on('loading', (transition, oldContainer) => {
            html.classList.remove('has-dom-ready');
            html.classList.remove('has-dom-ready-callback');
            html.classList.remove('has-dom-animated');

            html.classList.add('is-preloading');

            this.call('close','Nav');

            console.log('loading');
        });

        load.on('loaded', (transition, oldContainer, newContainer) => {
            
            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');

            let url = window.location.href;

            if(window.dataLayer) {
            window.dataLayer.push({
                    event: 'VirtualPageview',
                    virtualPageURL: window.location.pathname + window.location.search,
                    virtualPageTitle: document.title
                });
            }

            gsap.delayedCall(window.readyDelay,() => {
                html.setAttribute('data-theme','');
                html.classList.remove('is-preloading');
                html.classList.add('has-dom-ready');

                this.setSizes();
                
                body.setAttribute('class',newContainer.getAttribute('class'));

                gsap.delayedCall(window.readyCallbackDelay,() => {
                    html.classList.add('has-dom-ready-callback');
                    html.classList.add('has-dom-animated');
                });
                
            });
        });
    }

    setSizes() {
        
        if (window.innerHeight - document.documentElement.clientHeight > 0) {
            body.classList.add('has-scrollbar-y');
            document.documentElement.style.setProperty('--scrollbar',`${window.innerHeight - document.documentElement.clientHeight}px`);
        } else {
            body.classList.remove('has-scrollbar-y');
        }

        // screen height
        document.documentElement.style.setProperty('--app-availheight',`${window.screen.availHeight}px`);
        document.documentElement.style.setProperty('--app-height',`${window.innerHeight}px`);
        document.documentElement.style.setProperty('--app-height-negative',`-${window.innerHeight}px`);

        window.addEventListener('resize',() => {

            if(!window.isMobile) {
                document.documentElement.style.setProperty('--app-availheight',`${window.screen.availHeight}px`);
                document.documentElement.style.setProperty('--app-height',`${window.innerHeight}px`);
                document.documentElement.style.setProperty('--app-height-negative',`-${window.innerHeight}px`);
            }
        });
    }
}
